<template>
<div class="container">
  <div class="topBox">
    <img class="topBox_bg" src="../../../assets/images/parkService/parkingSearchSuccess.jpg" alt="">
    <div class="carkNumber">{{dataInfo.carCode|filterCarCode}}</div>
    <div class="parkName">
      <img class="parkName_icon" :src="require(`../../../assets/images/icon_location_${common.theme}.png`)" alt="">
      <div class="parkName_text">
        {{dataInfo.parkName}}
      </div>
    </div>
  </div>
  <div class="infoBox">
    <div class="info_line">
      <div class="info_left">入场时间</div>
      <div class="info_right">{{dataInfo.enterDate|filtersDate}}</div>
    </div>
    <div class="info_line">
      <div class="info_left">停车时长</div>
      <div class="info_right">{{dataInfo.parkingTime|filterParkingTime}}</div>
    </div>
    <div :class="['info_line',dataInfo.paidValue?'':'info_line2']">
      <div class="info_left">停车费</div>
      <div class="info_right">¥{{dataInfo.parkingFee|priceFormat}}</div>
    </div>
    <div class="info_line info_line2" v-if="dataInfo.paidValue">
      <div class="info_left">已支付</div>
      <div class="info_right">¥{{dataInfo.paidValue|priceFormat}}</div>
    </div>
    <div class="info_line info_line3">
      <div class="info_left">停车券</div>
      <div class="info_right" @click="showModal = true">
        <span class="none" v-if="numUse == 0">无可用</span>
        <span v-if="numUse > 0 && !freeAmount" class="canUse">{{numUse}}张可用</span>
        <span v-if="freeAmount > 0" class="price">-¥{{freeAmount}}</span>
        <img src="../../../assets/images/icon_indicator_next.png" />
      </div>
    </div>
    <div class="info_bottom">
      <div class="info_bottom_left">需支付</div>
      <div class="info_bottom_right">¥{{dataInfo.shouldPayValue-freeAmount | priceFormat}}</div>
    </div>
  </div>
  <div class="bottomBtn_wrap button">
    <div :class="['btn' ,'bottomBtn' ,'btn_default',dataInfo.shouldPayValue?'':'btn_Hui']" @click="createOrderNo">
      立即支付
    </div>
  </div>
  <mt-popup v-model="showModal" position="bottom" class="keyBox">
    <section class="top_btn">
        <span class="top_btn_left" @click="showModal = false">取消</span>
        <p class="top_btn_center">选择停车券</p>
        <span class="top_btn_right" @click="confirmCoupon">确定</span>
    </section>
    <section class="none_box" @click="noUseClick">
      <p class="none_box_left">不使用停车券</p>
      <span v-if="useCoupon" class="none_box_right"></span>
      <img v-else src="../../../assets/images/icon_check_0.png" />
    </section>
    <section class="coupon_list">
      <scroll
        :data="parkCouponDetailBeanList"
        :pulldown="false"
        :pullup="false"
        v-if="parkCouponDetailBeanList.length > 0"
      >
        <section class="coupon_item" v-for="(item,index) in parkCouponDetailBeanList" :key="index">
          <coupon-item :item="item" :selected="item.selected"  come="linting" @itemClick="itemClick"></coupon-item>
        </section>
        <p class="btn_height"></p>
      </scroll>
      <p class="no_message_text" v-else>暂无可用优惠券~</p>
    </section>
  </mt-popup>
</div>
</template>

<script>
import util from '../../../utils/util'
import {freeCall} from '../../../utils/api'
import {mapState} from 'vuex'
import ping from '../../../utils/pingpay.js'
import CouponItem from '../../parkingCoupon/components/couponItem'
import Scroll from "../../../components/scroll";
import storage from "../../../utils/storage";
export default {
  name: 'parkingSearch',
  props: {},
  components: {
    CouponItem,
    Scroll
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      showModal:false,
      licenseNumber: [],
      userSelect: 0,
      numUse:0,//可用张数
      showKeyboard: false, // 是否显示键盘
      keyBoardType: 1, // 键盘类型
      numClick: 2, // 数字是否可点 2:不可点
      textClick: 2, // 文字是否可点2:不可点
      dataInfo: {},
      orderInfo: {},
      parkCouponDetailBeanList:[],//停车券列表
      useCoupon:false,
      freeAmount:0,
      canCreateOrder:false,
      freeId:''
    }
  },
  filters: {
    filtersDate(value) {
      return value ? value.slice(0, 4) + '-' + value.slice(4, 6) + '-' + value.slice(6, 8) + ' ' + value.slice(8, 10) + ':' + value.slice(10, 12) + ':' + value.slice(12, 14) : '';
    },
    filterParkingTime(value) {
      return util.selvateTime(value) ? util.selvateTime(value) : '0分钟'
    },
    filterCarCode(value) {
      return value ? value.slice(0, 2) + '·' + value.slice(2) : '';
    }
  },
  created() {
   var str =storage.get("parkingSearchSuccess")  ;
   if(str){
      var data = JSON.parse(str)
      console.log("in getData")
      storage.set('parkingSearchSuccess', '')
      this.dataInfo = data;
      let list = data.parkCouponDetailBeanList || [];
      let num = 0;
      list.forEach(item=>{
          item.selected=false;
          if(item.available){
            num ++
          }
      })
      this.numUse = num;
      this.parkCouponDetailBeanList = list
   }else{
      this.fetchData();
   }

  },
  methods: {
    confirmCoupon(){
      this.showModal = false;
      if(!this.useCoupon){
        this.freeAmount = 0;
        this.freeId = '';
        return;
      }
      this.getFreeAmount()//获取优惠价格
    },
    // 选中停车券
    itemClick(val){
      console.log(val.id)
      let list = this.parkCouponDetailBeanList;
      let ids = [];
      // 免费券 或者 折扣券
      if(val.couponType == 1 || val.couponType == 4){
        list.forEach(item=>{
          if(item.id == val.id){
            item.selected = !item.selected;
          }else{
            item.selected = false;
          }
          if(item.selected){
            ids.push(item.id)
            this.useCoupon = true;
          }
        })
      }
      // 选中的是金额券或者是时间券
      if(val.couponType == 2 || val.couponType == 3){
        // isSuperimpose 1可以叠加 2 不可以叠加
        list.forEach(item=>{
          // 选中同类型的券,判断券是否可叠加
          if(val.couponType == item.couponType){
            if(val.isSuperimpose == 1 && item.id == val.id){
              item.selected = !item.selected;
            }else if(val.isSuperimpose == 2){
              if(item.id == val.id){
                item.selected = !item.selected;
              }else{
                item.selected = false;
              }
            }
          }else{
            item.selected = false;
          }
          if(item.selected){
            ids.push(item.id)
            this.useCoupon = true;
          }
        })
      }
      list.forEach((item,index)=>{
        this.$set(this.parkCouponDetailBeanList,index,item)
      })
      this.freeId = ids.join(",");
      console.log(ids)
      if(ids.length === 0){
        this.useCoupon = false;
      }
    },
    // 点击不使用优惠券
    noUseClick(){
      this.useCoupon = false;
      this.freeAmount = 0;
      this.freeId = '';
      let list = this.parkCouponDetailBeanList;
      list.forEach(item=>{
        item.selected = false;
      })
    },
    fetchData() {
      let postInfo = {
        'parkHeaderId': this.$route.query.parkHeaderId,
        'plateNo': this.$route.query.plateNo,
        'url': '/parking/rstParkBill/getParkFee'
      }
      util.showLoading();
      freeCall(postInfo).then(res => {
        console.log(res)
        util.hideLoading();
        if (res.res.code == 10000) {
          this.dataInfo = res.body.data;
          let list = res.body.data.parkCouponDetailBeanList || [];
          let num = 0;
          list.forEach(item=>{
            item.selected=false;
            if(item.available){
              num ++
            }
          })
          this.numUse = num;
          this.parkCouponDetailBeanList = list
        }
      });
    },
    paySuccess() {
      // storage.set('plateNo', this.$route.query.plateNo)
      this.$router.push(`/paySuccess?outEffectiveTime=${this.$route.query.outEffectiveTime}&plateNo=${this.$route.query.plateNo}`);
    },
    createOrderNo() {
      if(!this.dataInfo.shouldPayValue){
        return
      }
      if(this.canCreateOrder){
        return
      }
      this.canCreateOrder =true
      let value = this.dataInfo.enterDate
      let inTime = value ? value.slice(0, 4) + '.' + value.slice(4, 6) + '.' + value.slice(6, 8) + ' ' + value.slice(8, 10) + ':' + value.slice(10, 12) + ':' + value.slice(12, 14) : '';
      let postInfo = {
        "parkHeaderId": parseInt(this.$route.query.parkHeaderId),
        "subProjectId": this.common.marketInfo.id,
        'amount': this.dataInfo.shouldPayValue,
        "plateNo": this.dataInfo.carCode || this.$route.query.plateNo,
        "parkingCode": this.dataInfo.parkingCode || '',
        "openId": this.common.openId,
        "userId": this.common.userId ? this.common.userId : '',
        "userName": this.common.userId ? this.common.userTenantInfo.userName?this.common.userTenantInfo.userName:this.common.userInfo.userName : '',
        "phone": this.common.userId ? this.common.userInfo.phone || this.common.userInfo.account: '',
        "parkingFee":this.dataInfo.parkingFee,
        "chargeDate":this.dataInfo.chargeDate,
        'freeAmount': this.freeAmount,
        freeId:this.freeId,
        "inTime": inTime,
        "payAmount":this.dataInfo.shouldPayValue-this.freeAmount,
        'url': '/parking/rstParkBill/parkTemporaryBill'
      }
      util.showLoading();
      freeCall(postInfo).then(res => {
        util.hideLoading();
        if (res.res.code == 10000) {
          if(res.body.msg == "success"){
            this.orderInfo = res.body.data;
            // 价格是0或者返回的res.body.data是null的情况 跳成功页面
            if(!this.orderInfo || this.dataInfo.shouldPayValue-this.freeAmount === 0){
              this.paySuccess();
              this.canCreateOrder = false;
            }else{
              this.pingPay()
            }
          }else{
            this.canCreateOrder = false;
            util.showToast(res.body.msg);
          }
        }else{
          this.canCreateOrder = false;
          util.showToast('订单创建失败，请稍后再试');
        }
      });
    },
    pingPay() {
      let self = this;
      let params = {
        orderNo: this.orderInfo.orderNo,
        repairNo: '', // "报修单号",
        bussinessType: "7", //临时停车
        feeCode:this.$route.query.parkHeaderId,
        channel: 'wx_pub' // 渠道名
      };
      ping(
        params,
        '',
        res => {
          self.paySuccess();
          this.canCreateOrder = false;
        }, () => {
          util.showToast("支付失败");
          this.canCreateOrder = false;
        }, () => {
          this.canCreateOrder = false;
          util.showToast("支付取消");
        })
    },
    inputchange(value) {
      let arr = this.licenseNumber;
      if (arr.length === 8 && value !== 'delete') {
        return;
      }
      // 切换键盘
      if (this.keyBoardType === 1) {
        if (value === 'delete') {
          this.hideModal();
        } else {
          this.keyBoardType = 2;
          arr.push(value);
        }
      } else {
        if (value === 'delete') {
          arr.splice(-1, 1);
          if (arr.length === 0) {
            this.keyBoardType = 1;
          }
        } else {
          arr.push(value);
        }
      }
    },
    // 获取优惠价格
    getFreeAmount(){
      util.showLoading()
      let value = this.dataInfo.enterDate;
      let inTime = value ? value.slice(0, 4) + '.' + value.slice(4, 6) + '.' + value.slice(6, 8) + ' ' + value.slice(8, 10) + ':' + value.slice(10, 12) + ':' + value.slice(12, 14) : '';
      let params = {
        parkHeaderId: this.$route.query.parkHeaderId,
        amount:this.dataInfo.shouldPayValue,
        inTime:inTime,
        freeId:this.freeId,
		    url: "/parking/rstParkBill/getFreeAmount"
      }
      freeCall(params).then(res=>{
        console.log(res)
        util.hideLoading()
        if(res.res.code === 10000 && res.body && res.body.data){
          this.freeAmount = res.body.data.freeAmount
        }else{
          util.showToast(res.res.msg)
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
// 头部
.park_top {
    height: 240px;
    position: relative;
    .top_bg {
        width: 100%;
        height: 100%;
    }
    .market_box {
        position: absolute;
        top: 24px;
        left: 28px;
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        height: 60px;
        background: rgba(0,0,0,0.04);
        border-radius: 30px;
        padding: 0 20px 0 12px;
        img {
            width: 32px;
            height: 32px;
            margin-right: 8px;

        }
    }
    .login_btn {
        position: absolute;
        top: 24px;
        right: 28px;
        width: 140px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        box-sizing: border-box;
        .border(#1740da);
        color: #1740da;
        font-size: 24px;
        border-radius: 8px;
    }
}
.login_box {
    height: 108px;
    position: relative;
    .market_box {
        position: absolute;
        top: 24px;
        left: 28px;
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        height: 60px;
        background: rgba(0,0,0,0.04);
        border-radius: 30px;
        padding: 0 20px 0 12px;
        img {
            width: 32px;
            height: 32px;
            margin-right: 8px;

        }
    }
}
.card_box {
    margin-top: 48px;
    .title {
        font-size: 40px;
        color: rgba(51,51,51,1);
        line-height: 56px;
        text-align: center;
    }
}
.btn_box {
    margin: 0 40px 60px;
    .search_btn {
        height: 76px;
        line-height: 76px;
        text-align: center;
        color: #fff;
        background: @color17;
        border-radius: 8px;
        font-size: 32px;
    }
}
// 车牌号
.cardBox {
    .flex();
    justify-content: center;
    padding: 60px 0;
    background: #fff;
    .card_item {
        width: 72px;
        height: 84px;
        line-height: 84px;
        border-radius: 4px;
        .border();
        text-align: center;
        margin: 0 5px;
        position: relative;
        font-size: 34px;
        font-weight: bold;
        &:last-child {
            background: rgba(243,251,249,1);
            .border(rgba(198,238,225,1));
        }
        img {
            display: block;
            width: 80px;
            height: 30px;
            position: absolute;
            top: -18px;
            left: 50%;
            transform: translate(-50%);
        }
    }
    .curS {
        .border(rgba(23,64,218,1));
        &:last-child {
            .border(rgba(23,64,218,1));
        }
    }
}
// 历史记录
.history_data {
    position: relative;
    .history_title {
        font-size: 28px;
        color: rgba(153,153,153,1);
        line-height: 40px;
        height: 40px;
        text-align: center;
        position: relative;
        margin-bottom: 40px;
        &:after {
            content: '';
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(0,-50%);
            margin-left: -330px;
            height: 2px;
            width: 250px;
            background: #eaeaea;
        }
        &:before {
            content: '';
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(0,-50%);
            margin-left: 80px;
            height: 2px;
            width: 180px;
            background: #eaeaea;
        }
    }
    .history_delect {
        position: absolute;
        top: 0;
        right: 40px;
        width: 44px;
        height: 44px;
    }
    .history_list {
        margin-left: 28px;
        .flex();
        flex-direction: row;
        flex-wrap: wrap;
        .list_item {
            width: 218px;
            height: 68px;
            line-height: 68px;
            background: rgba(248,248,248,1);
            border-radius: 8px;
            text-align: center;
            font-size: 30px;
            color: #333;
            margin-right: 20px;
            margin-bottom: 20px;
        }
    }

}
.container {
    .topBox {
        height: 362px;
        width: 100%;
        align-items: center;
        display: flex;
        flex-direction: column;
        .topBox_bg {
            position: absolute;
            top: 40px;
            left: 154px;
            width: 444px;
            height: 202px;
            z-index: 1;
        }
        // background: url('') 4 76px;
        .carkNumber {
            position: relative;
            z-index: 2;
            height: 66px;
            font-size: 48px;
            color: rgba(51,51,51,1);
            line-height: 66px;
            letter-spacing: 1px;
            margin: 168px 0 28px;
        }
        .parkName {
            position: relative;
            z-index: 2;
            height: 40px;
            display: flex;
            .parkName_icon {
                width: 32px;
                height: 32px;
                margin: 4px 8px 4px 0;
                align-items: center;
            }
            .parkName_text {
                position: relative;
                z-index: 2;
                font-size: 28px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: rgba(0,0,0,1);
                line-height: 40px;
            }
        }
    }
    .infoBox {
        padding-top: 20px;
        width: 710px;
        margin: 0 20px;
        // min-height:418px;
        background: rgba(255,255,255,1);
        box-shadow: 0 12px 50px 0 rgba(0,0,0,0.08);
        border-radius: 8px;
        .info_line {
            height: 82px;
            display: flex;
            margin: 0 40px;
            align-items: center;
            .info_left {
                width: 130px;
                font-size: 30px;
                color: rgba(102,102,102,1);
                text-align: left;
            }
            .info_right {
                flex: 1;
                color: rgba(51,51,51,1);
                font-size: 30px;
                text-align: right;
                .flex();
                justify-content: flex-end;
                align-items: center;
                .none{
                  font-size:30px;
                  color:rgba(153,153,153,1);
                }
                .canUse{
                  height:40px;
                  padding:0 12px;
                  line-height: 40px;
                  background:rgba(252,63,86,0.1);
                  border-radius:20px;
                  font-size:26px;
                  color:rgba(252,63,86,1);
                }
                .price{
                  font-size:30px;
                  color:rgba(51,51,51,1);
                }
                img{
                  width:32px;
                  height:32px;
                  margin-left:4px;
                }
            }
        }
        .info_line2 {
            padding-bottom: 20px;
            border-bottom: 1px solid #EAEAEA;
        }
        .info_line3{
          margin-top:20px;
        }
        .info_bottom {
            height:50px;
            padding:20px 0 40px;
            margin: 0 40px;
            display: flex;
            align-items: center;
            .info_bottom_left {
                width: 130px;
                font-size: 36px;
                font-weight: 400;
                color: #333;
                text-align: left;
            }
            .info_bottom_right {
                flex: 1;
                font-weight: 500;
                color: #FD001B;
                font-size: 36px;
                text-align: right;
            }
        }
    }
    .bottomBtn_wrap {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 108px;
        background: #fff;
        .btn {
            width: 694px;
            height: 76px;
            background: rgba(218,218,218,1);
            border-radius: 4px;
            margin: 16px 28px;
            font-size: 32px;

            text-align: center;
            line-height: 76px;
            color: #fff;
        }
        .bottomBtn {
            background: #1740DA;
            color: #fff;
        }
        .btn_Hui{
          background:rgba(218,218,218,1)!important;
          color: #fff!important;
        }
    }
}
.top_btn{
  height:88px;
  justify-content: center;
  line-height: 88px;
  .flex();
  .top_btn_left{
    height:88px;
    padding:0 28px;
    font-size:28px;
    color:rgba(51,51,51,1);
  }
  .top_btn_center{
    flex:1;
    text-align: center;
    font-size:32px;
    color:rgba(51,51,51,1);
  }
  .top_btn_right{
    font-size:28px;
    color:rgba(23,64,218,1);
    padding:0 28px;
  }
}
.none_box{
  height:88px;
  background:rgba(248,248,248,1);
  border-radius:8px;
  padding:0 28px;
  margin:16px 20px;
  .flex();
  justify-content: space-between;
  align-items: center;
  .none_box_left{
    font-size:28px;
    color:rgba(51,51,51,1);
  }
  .none_box_right{
    width:36px;
    height:36px;
    border-radius:100%;
    background:rgba(255,255,255,1);
    border:1px solid rgba(218,218,218,1);
  }
  img{
    width:36px;
    height:36px;
  }
}
  .coupon_list{
    height:600px;
    .flex(column);
    .coupon_item{
      margin:20px;
    }
    .btn_height{
      height:20px;
    }
    .scroll_box{
      margin-bottom:20px;
    }
    .no_message_text{
      height:44px;
      font-size:32px;
      color:rgba(201,201,201,1);
      line-height:44px;
      margin-top:240px;
      text-align: center;
    }
  }
</style>
